import { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Switch, Tabs } from "antd";

import Fetch from "components/Fetch";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import DeleteButton from "components/buttons/DeleteButton";
import Loading from "components/App/Loading";
import ManageCouponButton from "components/buttons/ManageCouponButton";
// import Filters from "components/dashboard/Filters";
import { getUserState } from "state/selector";
import { states } from "constants/app";
import { GlassCard } from "components/App/styled";
import Table from "./Table";

const Filters = ({ setStatus, reload }) => (
  <div style={{ marginTop: 32 }}>
    نمایش همه :
    <Switch
      style={{ marginRight: 8 }}
      onChange={(state) => {
        reload(true);
        setStatus(state ? "" : "/active");
      }}
    />
  </div>
);

function Index(props) {
  const [reload, setReload] = useState(false);
  const [coupons, setCoupons] = useState(false);
  const [status, setStatus] = useState("/active");
  const [manageCoponModal, setManageCoponModal] = useState(false);

  useEffect(() => {
    Fetch.get(`/coupon`, (res) => {
      if (res) {
        console.log("dashboard/coupons data", res);
        setCoupons(res);
        setReload(false);
      }
    });
  }, [reload, status]);

  if (!coupons) {
    return <Loading />;
  }
  return (
    <Container>
      <GlassCard style={{ padding: "16px 4px" }}>
        <ManageCouponButton
          reload={setReload}
          data={coupons}
          visible={manageCoponModal}
          setVisible={setManageCoponModal}
        />
      </GlassCard>
      <TableContainer>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="فعال" key="1">
            <Table
              data={coupons?.active}
              reload={reload}
              setReload={setReload}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="غیرفعال" key="2">
            <Table
              data={coupons?.unactive}
              reload={reload}
              setReload={setReload}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="منقضی شده" key="3">
            <Table
              data={coupons?.expired}
              reload={reload}
              setReload={setReload}
            />
          </Tabs.TabPane>
        </Tabs>
      </TableContainer>
    </Container>
  );
}
const mapStateToProps = (state) => {
  const user = getUserState(state);
  return { user };
};
export default connect(mapStateToProps)(Index);
const Container = styled.div`
  color: ${colors.dark};
`;
const TableContainer = styled.div``;
